module.exports = __webpack_public_path__ + "fonts/Sunflower-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Sunflower/Sunflower-Medium.ttf
// module id = 3466
// module chunks = 0